import { get } from 'lodash';

export const modal = (state = {}, action) => {
  switch (action.type) {
    case 'OPEN_MODAL': {
      return {
        open: true,
        type: get(action, 'payload.type'),
        data: get(action, 'payload.data'),
      };
    }
    case 'CLOSE_MODAL': {
      return {};
    }
    default:
      return state;
  }
};
